import { OnInit, } from '@angular/core';
import { DatastoreCollection, } from '@freelancer/datastore';
import { ModalService } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { HeadingSize } from '@freelancer/ui/heading';
import { IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { ModalSize } from '@freelancer/ui/modal';
import { FontColor, FontSize, FontWeight } from '@freelancer/ui/text';
import { HireMeWebappModalComponent } from 'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component';
import * as Rx from 'rxjs';
import { map, take } from 'rxjs/operators';
var UserPortfolioItemOverlayComponent = /** @class */ (function () {
    function UserPortfolioItemOverlayComponent(modalService) {
        this.modalService = modalService;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.FontColor = FontColor;
        this.FontSize = FontSize;
        this.FontWeight = FontWeight;
        this.HeadingSize = HeadingSize;
        this.IconSize = IconSize;
        this.Margin = Margin;
        this.VerticalAlignment = VerticalAlignment;
    }
    UserPortfolioItemOverlayComponent.prototype.ngOnInit = function () {
        this.itemSkills$ = Rx.combineLatest([
            this.skillsCollection.valueChanges(),
            this.portfolioItem$,
        ]).pipe(map(function (_a) {
            var skills = _a[0], item = _a[1];
            return skills.filter(function (s) { return item.jobs.includes(s.id); });
        }));
    };
    UserPortfolioItemOverlayComponent.prototype.hiremeAction = function () {
        var _this = this;
        this.modalService.close();
        this.hireMeUser$
            .pipe(take(1))
            .toPromise()
            .then(function (hireMeUser) {
            var userId = hireMeUser.profileUserId;
            _this.modalService.open(HireMeWebappModalComponent, {
                inputs: {
                    profileUserId: userId,
                },
                size: ModalSize.XSMALL,
                edgeToEdge: true,
            });
        });
    };
    return UserPortfolioItemOverlayComponent;
}());
export { UserPortfolioItemOverlayComponent };
